//////////////////////////////////////////////////////////////////////////////
// Harmony Learning Maps
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Map configuration including styles and icons
//////////////////////////////////////////////////////////////////////////////
const mapConfig = {
  styles: [{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d0b78f"}]},{"featureType":"water","elementType":"labels","stylers":[{"color":"#ffffff"},{"visibility":"off"}]}],
  icons: {
    active: maps_theme_obj.img_url + '/mapicon-active-v3.png',
    inactive: maps_theme_obj.img_url + '/mapicon-inactive-v3.png',
    width: 34,
    height: 48
  },
  radius: 15000, // 15 kilometers radius
  enableDebugPins: false, // Toggle for debug pins
  enableOffset: false, // Toggle for map offsetting
  offsetDirection: 'right', // Offset direction ('left' or 'right')
  mediaQueryBreakpoints: {
    576: false, // Disable offset at screen widths >= 576px (sm and below).
    768: false,  // Enable offset at screen widths >= 768px (md).
    992: true,  // Enable offset at screen widths >= 992px (lg).
    1200: true, // Enable offset at screen widths >= 1200px (xl).
    1400: true  // Enable offset at screen widths >= 1400px (xxl).
  },
  // Configuration for the Google Places Autocomplete search box
  placeSearchOptions: {
    // Restrict the autocomplete search to only show region-level results
    types: ['(regions)'], // Restrict the search to regions (localities, suburbs). Can be a single type or an array of types (e.g., '(regions)', 'geocode', 'address', 'establishment', '(cities)')

    // Restrict the autocomplete results to a specific country
    componentRestrictions: {
      country: 'au' // Restrict results to Australia. Can be an array of country codes (e.g., ['us', 'ca'] for the United States and Canada).
    }
  },
  clustering: {
    enabled: true, // Enable marker clustering
    textColor: "#5f5343", // Cluster count font-color
    textSize: 11, // Cluster count font-size
    gridSize: 40, // Size of the square grid (in pixels) within which markers are grouped into a cluster
    maxZoom: 11 // Zoom level at which marker clustering stops
  },
  debug: false // Add this line to enable/disable debug logging
};

//////////////////////////////////////////////////////////////////////////////
// Declare map variables in global scope
//////////////////////////////////////////////////////////////////////////////
let map;
let isUsingLocation = false;
let currentActiveMarker = null;
let debugPins = [];
let placeSearch;
let markersObject = [];
var markerClusterer = null;

//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Initialise functions
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Initialise the map
// This function initializes the Google Map, sets up the map configuration,
// and adds event listeners for various map interactions including resizing.
//////////////////////////////////////////////////////////////////////////////
function initMap() {
  // Initial center coordinates and zoom level for the map (Brisbane)
  const initialCenter = { lat: -27.3817412, lng: 152.8283958 };
  const initialZoom = 10;

  // Create a new Google Map instance
  map = new google.maps.Map(document.querySelector('.js-stockists-map'), {
    zoom: initialZoom,
    center: initialCenter,
    styles: mapConfig.styles,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    scaleControl: false,
    rotateControl: false,
    zoomControl: true,
  });

  // Adjust the initial center to shift markers to the right half of the map
  google.maps.event.addListenerOnce(map, 'bounds_changed', adjustMapCenter);

  // Initialise the Autocomplete for places search
  const input = document.querySelector('.js-place-search');
  placeSearch = new google.maps.places.Autocomplete(input, mapConfig.placeSearchOptions);
  placeSearch.addListener('place_changed', handlePlacesChanged);

  // Listen for the enter key press on the search input field
  input.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission
      const query = input.value; // Get the value from the input field
      performSearch(query); // Perform the search with the user input
    }
  });

  // Create an InfoWindow for displaying information
  const infoWindow = new google.maps.InfoWindow();

  // Sort stockists alphabetically for the initial load
  const sortedStockists = [...mapData.stockists].sort((a, b) => a.title.localeCompare(b.title));

  // Create a LatLngBounds instance to fit the map to the markers
  const bounds = new google.maps.LatLngBounds();

  // Iterate through the sorted stockists data and create markers
  markersObject = [];
  sortedStockists.forEach(stockist => {
    createMarker(stockist, infoWindow, bounds);
  });

  // Create the clustered marker
  setTimeout(function(){
    createMarkerClustering();
  },1000)
  
  // Adjust the map to fit the bounds of the markers
  map.fitBounds(bounds);
  
  // Add event listeners for map interactions
  google.maps.event.addListener(map, 'bounds_changed', resetLocationButton);
  google.maps.event.addListener(map, 'dragend', updateVisibleStockists); // Update stockists on drag end
  google.maps.event.addListener(map, 'zoom_changed', updateVisibleStockists ); // Update stockists on zoom change

  // Adjust the map center on window resize
  let resizeTimeout;
  let lastWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const bounds = new google.maps.LatLngBounds();

        // Sort stockists alphabetically
        const sortedStockists = [...mapData.stockists].sort((a, b) => a.title.localeCompare(b.title));
        
        // Clear the stockists list
        updateStockistList([]);

        // Iterate through the sorted stockists data and update markers and bounds
        sortedStockists.forEach(stockist => {
          if (stockist.marker && stockist.marker.getMap() === map) {
            bounds.extend(stockist.marker.getPosition());
          }
        });

        // Fit the map to the new bounds
        map.fitBounds(bounds);
        adjustMapCenter();

        // Update the stockists list with sorted stockists
        updateStockistList(sortedStockists);
      }, 100);
    }
  });

  // Initialise search from query string if present
  setTimeout(initSearchFromQuery, 1000);

  // Update stockist list with sorted stockists after a slight delay
  setTimeout(() => {
    updateStockistList(sortedStockists);
  }, 500);

}

//////////////////////////////////////////////////////////////////////////////
// Check if Google Maps API is loaded and initialise the map
// This function checks if the Google Maps API is loaded and, if so,
// initialises the map. If the API is not loaded, it retries every second.
//////////////////////////////////////////////////////////////////////////////
function checkGoogleMaps() {
  // Check if the Google Maps API is available
  if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
    // Google Maps API is loaded, initialise the map
    initMap();
  } else {
    // Google Maps API is not loaded, retry after a delay
    // Retry every second to check if the Google Maps API is loaded
    // console.error('Google Maps API is not loaded, retrying...');
    setTimeout(checkGoogleMaps, 1000);
  }
}

//////////////////////////////////////////////////////////////////////////////
// Initialise DOM-dependent functionality
// This function sets up event listeners for DOM elements and checks if the
// Google Maps API is loaded once the DOM content is fully loaded.
//////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function() {
  // Add click event listener to the "Use My Location" button
  document.querySelector('.js-use-my-location').addEventListener('click', handleUseMyLocation);

  // Add click event listener to the "View All Locations" button
  document.querySelector('.js-view-all-locations').addEventListener('click', handleViewAllLocations);

  // Add keypress event listener for the "Enter" key on the search input
  document.querySelector('.js-place-search').addEventListener('keypress', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const query = this.value;
      performSearch(query);
    }
  });

  // Add click event listener for the submit button
  document.querySelector('.js-place-search-submit').addEventListener('click', function(event) {
    event.preventDefault();
    const query = document.querySelector('.js-place-search').value;
    performSearch(query);
  });
  
  // Check if Google Maps API is loaded and initialise the map
  checkGoogleMaps();

  // Set dynamic height on page load
  setDynamicHeight();

  // Update dynamic height on window resize
  window.addEventListener('resize', setDynamicHeight);
});


//////////////////////////////////////////////////////////////////////////////
// Parse query string and initialise search if present
//////////////////////////////////////////////////////////////////////////////
function initSearchFromQuery() {
  // Get URL search parameters
  const urlParams = new URLSearchParams(window.location.search);
  // Retrieve the 'stockist_search' parameter value
  const query = urlParams.get('stockist_search');
  //debugLog("Query from URL:", query);

  // If the query is "all", handle the view all locations logic
  if (query === 'all') {
    handleViewAllLocations();
    setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
  } else if (query) {
    // Get the search input element
    const searchInput = document.querySelector('.js-place-search');
    // Set the input value to the search query
    searchInput.value = query;
    debugLog("Search input value set to:", searchInput.value);

    // Initialise the Google Places Autocomplete with the input element
    const placeSearch = new google.maps.places.Autocomplete(searchInput, mapConfig.placeSearchOptions);
    debugLog("Autocomplete instance created:", placeSearch);

    // Add an event listener to handle place changes
    placeSearch.addListener('place_changed', handlePlacesChanged);

    // Trigger a simulated search to update the map based on the query
    const service = new google.maps.places.PlacesService(map);
    service.textSearch({ query: query }, function(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        debugLog("PlacesService textSearch results:", results);
        // Set the input value to the first search result's formatted address
        searchInput.value = results[0].formatted_address;
        debugLog("Search input value updated to first result's address:", searchInput.value);

        // Manually set the place details to the Autocomplete instance
        placeSearch.set('place', results[0]);

        // Manually trigger the place_changed event
        google.maps.event.trigger(searchInput, 'place_changed');
      } else {
        console.log("PlacesService textSearch failed with status:", status);
      }
      // Scroll smoothly to the map section after the map updates
      setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
    });

    // Update display and class on .js-stockists-list and .js-stockists-listing-wrapper
    document.querySelector('.js-stockists-list').style.display = 'block';
    document.querySelector('.js-stockists-listing-wrapper').classList.add('h-100');

    // Set dynamic height after updating the display
    setDynamicHeight();
  }
}




//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Event Handlers
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Handle places changed event for the Autocomplete
//////////////////////////////////////////////////////////////////////////////
function handlePlacesChanged() {
  debugLog("Using handlePlacesChanged()");
  debugLog("Autocomplete instance:", this);

  // Get the place from the Autocomplete
  const place = this.getPlace();
  debugLog("Place selected from Autocomplete:", place);

  if (!place.geometry) {
    console.log("Returned place contains no geometry");
    return;
  }

  // Initialise bounds for the new map view
  const bounds = new google.maps.LatLngBounds();

  // Get the user's selected location and create bounds around it
  const userLocation = place.geometry.location;
  const userBounds = new google.maps.Circle({
    center: userLocation,
    radius: mapConfig.radius
  }).getBounds();

  // Clear existing list of stockists and reset scroll position
  const stockistsList = document.querySelector('.js-stockists-list');
  stockistsList.innerHTML = '';
  stockistsList.scrollTop = 0;

  // Reset the active marker and remove active class from the list
  resetActiveMarker();
  clearDebugPins(); // Clear debug pins

  // Remove existing markers from the map
  /*
  mapData.stockists.forEach(stockist => {
    if (stockist.marker) {
      stockist.marker.setMap(null);
    }
  });
  */

  // Collect stockists within the bounds and calculate their distances from the user location
  const stockistsWithinBounds = mapData.stockists
    .map(stockist => {
      const position = new google.maps.LatLng(stockist.lat, stockist.lng);
      const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, position);
      return { ...stockist, distance };
    })
    .filter(stockist => userBounds.contains(new google.maps.LatLng(stockist.lat, stockist.lng)));

  // Sort stockists by distance from the user location
  stockistsWithinBounds.sort((a, b) => a.distance - b.distance);

  // Create markers for the sorted stockists and extend the map bounds to include them
  markersObject = [];
  stockistsWithinBounds.forEach(stockist => {
    const position = new google.maps.LatLng(stockist.lat, stockist.lng);
    bounds.extend(position);
    createMarker(stockist, null, bounds);
  });

  // Add a debug pin for the searched location
  if (mapConfig.enableDebugPins) {
    createDebugPin(userLocation, mapConfig.icons.debugSearched);
  }

  // Extend the bounds to include the user location for correct fit
  bounds.extend(userLocation);

  // Adjust the map to fit the new bounds
  map.fitBounds(bounds);

  // Adjust the map center if offsetting is enabled
  if (mapConfig.enableOffset) {
    adjustMapCenter();
  }

  // Update the stockists list with sorted stockists
  updateStockistList(stockistsWithinBounds);

  // Update display and class on .js-stockists-list and .js-stockists-listing-wrapper
  document.querySelector('.js-stockists-list').style.display = 'block';
  document.querySelector('.js-stockists-listing-wrapper').classList.add('h-100');

  // Set dynamic height after updating the display
  setDynamicHeight();
}

//////////////////////////////////////////////////////////////////////////////
// Perform search based on user input
// This function is triggered when the user presses enter in the search box.
//////////////////////////////////////////////////////////////////////////////
function performSearch(query) {
  const service = new google.maps.places.PlacesService(map);

  // Perform a text search using Google Places API
  service.textSearch({ query: query }, function(results, status) {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      debugLog("Text search results:", results);

      // Set the input value to the first result's formatted address
      const input = document.querySelector('.js-place-search');
      input.value = results[0].formatted_address;

      // Manually set the place details to the existing Autocomplete instance
      placeSearch.set('place', results[0]);

      // Manually trigger the place_changed event
      google.maps.event.trigger(input, 'place_changed');
    } else {
      console.log("Text search failed with status:", status);
    }
  });
}

//////////////////////////////////////////////////////////////////////////////
// Handle "Use My Location" functionality
//////////////////////////////////////////////////////////////////////////////
function handleUseMyLocation() {
  // Select DOM elements
  const locationStatus = document.querySelector('.js-location-status');
  const locationLoading = document.querySelector('.js-location-loading');
  const useMyLocation = document.querySelector('.js-use-my-location');
  const stockistsList = document.querySelector('.js-stockists-list');
  const searchInput = document.querySelector('.js-place-search');

  // Clear the search input
  searchInput.value = '';

  // Remove the "stockist_search" parameter from the URL
  const url = new URL(window.location);
  url.searchParams.delete('stockist_search');
  window.history.replaceState({}, '', url);

  // Show loading indicator and hide status and button
  locationLoading.style.display = 'block';
  useMyLocation.style.display = 'none';
  locationStatus.style.display = 'none';

  // Check if geolocation is supported
  if (navigator.geolocation) {
    isUsingLocation = true; // Set the flag for location usage
    navigator.geolocation.getCurrentPosition(position => {
      // Get the user's location
      const userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
      const userBounds = new google.maps.Circle({
        center: userLocation,
        radius: mapConfig.radius
      }).getBounds();

      const bounds = new google.maps.LatLngBounds();

      // Clear existing list and reset scroll position
      stockistsList.innerHTML = '';
      stockistsList.scrollTop = 0;

      // Reset the active marker and remove active class
      resetActiveMarker();
      clearDebugPins(); // Clear debug pins

      // Collect stockists within the bounds and calculate their distances
      const stockistsWithinBounds = mapData.stockists
        .map(stockist => {
          const position = new google.maps.LatLng(stockist.lat, stockist.lng);
          const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, position);
          return { ...stockist, distance };
        })
        .filter(stockist => userBounds.contains(new google.maps.LatLng(stockist.lat, stockist.lng)));

      // Sort stockists by distance from the user's location
      stockistsWithinBounds.sort((a, b) => a.distance - b.distance);

      // Create markers for the sorted stockists and extend the map bounds to include them
      markersObject = [];
      stockistsWithinBounds.forEach(stockist => {
        const position = new google.maps.LatLng(stockist.lat, stockist.lng);
        bounds.extend(position);
        createMarker(stockist, null, bounds);
      });

      // Create debug pin for "Use My Location" if enabled
      if (mapConfig.enableDebugPins) {
        createDebugPin(userLocation, mapConfig.icons.debugLocation);
      }

      // Adjust the map to fit the new bounds
      map.fitBounds(bounds);
      adjustMapCenter();
      locationLoading.style.display = 'none'; // Hide loading indicator
      locationStatus.style.display = 'block'; // Show location status

      // Delay unsetting the flag to ensure the status remains visible
      setTimeout(() => {
        isUsingLocation = false;
      }, 1000);

      // Update display and class on .js-stockists-list and .js-stockists-listing-wrapper
      stockistsList.style.display = 'block';
      document.querySelector('.js-stockists-listing-wrapper').classList.add('h-100');

      // Set dynamic height after updating the display
      setDynamicHeight();

    }, () => {
      // Handle error when unable to retrieve location
      locationLoading.style.display = 'none';
      useMyLocation.style.display = 'block';
      alert("Unable to retrieve your location.");
      isUsingLocation = false; // Unset the flag
    });
  } else {
    // Handle case when geolocation is not supported
    locationLoading.style.display = 'none';
    useMyLocation.style.display = 'block';
    alert("Geolocation is not supported by this browser.");
    isUsingLocation = false; // Unset the flag
  }
}

//////////////////////////////////////////////////////////////////////////////
// Handle "View All Locations" functionality
// This function handles the event when the "View All Locations" button is clicked.
// It clears the search input, removes the "stockist_search" parameter from the URL,
// and updates the map and stockist list to show all locations in alphabetical order.
//////////////////////////////////////////////////////////////////////////////
function handleViewAllLocations() {
  // Get references to the stockists list and search input elements
  const stockistsList = document.querySelector('.js-stockists-list');
  const searchInput = document.querySelector('.js-place-search');

  // Clear the search input
  searchInput.value = '';

  // Remove the "stockist_search" parameter from the URL
  const url = new URL(window.location);
  url.searchParams.delete('stockist_search');
  window.history.replaceState({}, '', url);

  // Clear existing list of stockists and scroll to the top
  stockistsList.innerHTML = '';
  stockistsList.scrollTop = 0;

  // Reset the active marker and remove active class from list items
  resetActiveMarker();
  clearDebugPins(); // Clear debug pins

  // Create a LatLngBounds instance to fit the map to the markers
  const bounds = new google.maps.LatLngBounds();

  // Sort stockists alphabetically for displaying all locations
  const sortedStockists = [...mapData.stockists].sort((a, b) => a.title.localeCompare(b.title));

  // Iterate through the sorted stockists data and create markers
  // Remove existing markers from the map
  mapData.stockists.forEach(stockist => {
    if (stockist.marker) {
      stockist.marker.setMap(null);
    }
  });
  markersObject = [];
  sortedStockists.forEach(stockist => {
    createMarker(stockist, new google.maps.InfoWindow(), bounds);
  });

  // Create the clustered marker
  setTimeout(function(){
    refreshMarkerClustering();
  },1000)

  // Adjust the map to fit the bounds of the markers
  map.fitBounds(bounds);
  adjustMapCenter();

  // Update stockist list with sorted stockists
  updateStockistList(sortedStockists);

  // Update display and class on .js-stockists-list and .js-stockists-listing-wrapper
  stockistsList.style.display = 'block';
  document.querySelector('.js-stockists-listing-wrapper').classList.add('h-100');

  // Set dynamic height after updating the display
  setDynamicHeight();

  // Scroll smoothly to the map section after updating the display
  // setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
}

//////////////////////////////////////////////////////////////////////////////
// Set the active marker
// This function sets a given marker as the active marker, changing its appearance,
// and ensuring the associated list item is highlighted. It also repositions the map
// if necessary to keep the marker within the visible bounds.
//////////////////////////////////////////////////////////////////////////////
function setActiveMarker(activeMarker, zoom = false) {
  // Reset the previous active marker to inactive state
  if (currentActiveMarker) {
    currentActiveMarker.setIcon({
      url: mapConfig.icons.inactive, // Set inactive icon
      scaledSize: new google.maps.Size(mapConfig.icons.width, mapConfig.icons.height), // Size of the inactive icon
      anchor: new google.maps.Point(mapConfig.icons.width / 2, mapConfig.icons.height)
    });
    currentActiveMarker.setZIndex(null); // Reset zIndex of previous active marker

    // Remove the active class from the previous list item
    const prevActiveListItem = document.querySelector('.js-stockists-list .list-group-item.active');
    if (prevActiveListItem) {
      prevActiveListItem.classList.remove('active');
    }
  }

  // Set the new marker to active state
  activeMarker.setIcon({
    url: mapConfig.icons.active, // Set active icon
    scaledSize: new google.maps.Size(mapConfig.icons.width, mapConfig.icons.height), // Size of the active icon
    anchor: new google.maps.Point(mapConfig.icons.width / 2, mapConfig.icons.height)
  });
  activeMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the front
  map.setZoom(mapConfig.clustering.maxZoom + 1);

   // Stop any existing bounce
   // activeMarker.setAnimation(null);
   // activeMarker.setAnimation(google.maps.Animation.DROP);

  // Ensure the marker is within the right 50% of the map
  const mapBounds = map.getBounds();
  const mapCenter = map.getCenter();
  const mapSpan = mapBounds.toSpan();
  
  const markerPosition = activeMarker.getPosition();
  const leftBoundaryLng = mapCenter.lng() - mapSpan.lng() / 2.5; // Define the right 50% boundary
  const rightBoundaryLng = mapCenter.lng() + mapSpan.lng() / 2.5; // Define the right 50% boundary
  const topBoundaryLng = mapCenter.lat() - mapSpan.lat() / 2.5; // Define the top 50% boundary
  const bottomBoundaryLng = mapCenter.lat() + mapSpan.lat() / 2.5; // Define the bottom 50% boundary

  if ( ((markerPosition.lng() > rightBoundaryLng ) ||
       (markerPosition.lng() < leftBoundaryLng ) ||
       (markerPosition.lat() > bottomBoundaryLng ) ||
       (markerPosition.lat() < topBoundaryLng )) || 
       !mapBounds.contains(markerPosition) ) {
    // Calculate the new center point to shift the marker to the right 50%
    const newCenter = {
      lat: markerPosition.lat(),
      lng: markerPosition.lng()
      //lng: markerPosition.lng() - mapSpan.lng() / 4
    };
    map.setCenter(newCenter);
    updateVisibleStockists();
    setTimeout(function(){
      const stockistsList = document.querySelector('.js-stockists-list');
      stockistsList.scrollTop = 0;
    },200);
  }

  // Add the active class to the corresponding list item
  const activeListItem = document.querySelector(`.js-stockists-list a[data-stockist-id="${activeMarker.stockistId}"]`);
  if (activeListItem) {
    activeListItem.classList.add('active');
  }

  // Update display and class on .js-stockists-list and .js-stockists-listing-wrapper
  const stockistsList = document.querySelector('.js-stockists-list');
  const stockistListingWrapper = document.querySelector('.js-stockists-listing-wrapper');
  if (stockistsList.style.display !== 'block' || !stockistListingWrapper.classList.contains('h-100')) {
    stockistsList.style.display = 'block';
    stockistListingWrapper.classList.add('h-100');
  }

  // Update the current active marker reference
  currentActiveMarker = activeMarker;
}

//////////////////////////////////////////////////////////////////////////////
// Reset the active marker and remove active class from list items
// This function resets the currently active marker to its inactive state
// and removes the active class from the corresponding list item.
//////////////////////////////////////////////////////////////////////////////
function resetActiveMarker() {
  if (currentActiveMarker) {
    // Set the current active marker to inactive state
    currentActiveMarker.setIcon({
      url: mapConfig.icons.inactive, // Set inactive icon
      scaledSize: new google.maps.Size(mapConfig.icons.width, mapConfig.icons.height), // Sise of the inactive icon
      anchor: new google.maps.Point(mapConfig.icons.width / 2, mapConfig.icons.height)
    });
    currentActiveMarker.setZIndex(null); // Reset zIndex of the active marker
    currentActiveMarker = null; // Clear the reference to the active marker
  }

  // Remove the active class from the previously active list item
  const prevActiveListItem = document.querySelector('.js-stockists-list .list-group-item.active');
  if (prevActiveListItem) {
    prevActiveListItem.classList.remove('active');
  }
}

//////////////////////////////////////////////////////////////////////////////
// Revert back to "Use My Location" on map interaction
// This function resets the UI elements related to the "Use My Location"
// functionality if the user is not currently using the location feature.
//////////////////////////////////////////////////////////////////////////////
function resetLocationButton() {
  // Check if the user is not currently using the location feature
  if (!isUsingLocation) {
    // Hide the location status element
    document.querySelector('.js-location-status').style.display = 'none';

    // Hide the location loading indicator
    document.querySelector('.js-location-loading').style.display = 'none';

    // Show the "Use My Location" button
    document.querySelector('.js-use-my-location').style.display = 'block';
  }
}

//////////////////////////////////////////////////////////////////////////////
// Update the visible stockists based on map bounds
//////////////////////////////////////////////////////////////////////////////
function updateVisibleStockists() {
  const bounds = map.getBounds();
  const stockistsList = document.querySelector('.js-stockists-list');
  stockistsList.innerHTML = '';
  // stockistsList.scrollTop = 0; // Scroll to the top

  // Collect visible stockists
  const visibleStockists = mapData.stockists.filter(stockist =>
    stockist.marker && bounds.contains(stockist.marker.getPosition())
  );

  // Sort visible stockists by proximity to the current map center
  const mapCenter = map.getCenter();
  visibleStockists.sort((a, b) => {
    const distanceA = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, a.marker.getPosition());
    const distanceB = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, b.marker.getPosition());
    return distanceA - distanceB;
  });

  // Add visible stockists to the list
  visibleStockists.forEach(stockist => addStockistToList(stockist, stockist.marker));
}




//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Utility Functions
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Debug log function
//////////////////////////////////////////////////////////////////////////////
function debugLog(...args) {
  if (mapConfig.debug) {
    console.log(...args);
  }
}
//////////////////////////////////////////////////////////////////////////////
// Set dynamic height for .js-stockists-list
// This function calculates and sets the dynamic height for the stockists list
// based on the available height within the listing wrapper and search elements,
// taking into account the padding adjustments.
//////////////////////////////////////////////////////////////////////////////
function setDynamicHeight() {
  const stockistsListingColumn = document.querySelector('.js-stockists-listing-column');
  const stockistsListingWrapper = document.querySelector('.js-stockists-listing-wrapper');
  const stockistsSearch = document.querySelector('.js-stockists-search');
  const stockistsList = document.querySelector('.js-stockists-list');

  if (stockistsListingColumn && stockistsListingWrapper && stockistsSearch && stockistsList) {
    // Calculate the padding of the listing column
    const columnStyle = window.getComputedStyle(stockistsListingColumn);
    const columnPaddingTop = parseFloat(columnStyle.paddingTop);
    const columnPaddingBottom = parseFloat(columnStyle.paddingBottom);
    const columnTotalPadding = columnPaddingTop + columnPaddingBottom;

    // Calculate 25% of the total padding
    const paddingAdjustment = columnTotalPadding * 0.25;

    // Calculate the padding of the listing wrapper
    const wrapperStyle = window.getComputedStyle(stockistsListingWrapper);
    const paddingTop = parseFloat(wrapperStyle.paddingTop);
    const paddingBottom = parseFloat(wrapperStyle.paddingBottom);
    const totalPadding = paddingTop + paddingBottom;

    // Calculate available height considering the padding and subtracting the padding adjustment
    const availableHeight = stockistsListingWrapper.clientHeight - stockistsSearch.clientHeight - totalPadding - paddingAdjustment;

    // Ensure availableHeight is not negative
    const finalHeight = Math.max(availableHeight, 0);

    // Log the calculated values for debugging
    debugLog('Column Padding Top:', columnPaddingTop);
    debugLog('Column Padding Bottom:', columnPaddingBottom);
    debugLog('Column Total Padding:', columnTotalPadding);
    debugLog('Padding Adjustment (25%):', paddingAdjustment);
    debugLog('Wrapper Padding Top:', paddingTop);
    debugLog('Wrapper Padding Bottom:', paddingBottom);
    debugLog('Total Wrapper Padding:', totalPadding);
    debugLog('Available Height:', availableHeight);
    debugLog('Final Height:', finalHeight);

    // Apply the calculated height to the stockists list
    stockistsList.style.height = `${finalHeight}px`;
  }
}

//////////////////////////////////////////////////////////////////////////////
// Create a marker for a stockist
// This function creates a map marker for a given stockist, adds it to the map,
// and includes it in the list of stockists.
//////////////////////////////////////////////////////////////////////////////
function createMarker(stockist, infoWindow, bounds) {
  // Create a LatLng object for the stockist's position
  const position = new google.maps.LatLng(stockist.lat, stockist.lng);

  // Extend the map bounds to include the new position
  bounds.extend(position);

  // Create the marker object
  const curmap = (mapConfig.clustering.enabled)?null:map;
  const marker = new google.maps.Marker({
    position: position, // Set the position of the marker
    map: curmap, // Associate the marker with the map
    title: stockist.title, // Set the title of the marker
    icon: {
      url: mapConfig.icons.inactive, // URL for the marker icon
      scaledSize: new google.maps.Size(mapConfig.icons.width, mapConfig.icons.height), // Sise of the marker icon
      anchor: new google.maps.Point(mapConfig.icons.width / 2, mapConfig.icons.height)
    }
  });

  // Store the stockist ID in the marker for reference
  marker.stockistId = stockist.id;

  // Add a click listener to the marker to handle activation and scrolling
  marker.addListener('click', () => {
    setActiveMarker(marker); // Highlight the marker when clicked
    scrollToListItem(stockist.id); // Scroll to the list item when the marker is clicked
  });

  // Store the marker in the stockist object for future reference
  stockist.marker = marker;
  markersObject.push(marker);

  // Add the stockist to the list of stockists
  addStockistToList(stockist, marker);
}

//////////////////////////////////////////////////////////////////////////////
// Add a stockist to the list
// This function creates a list item for a stockist and appends it to the list
// of stockists. It also sets up event listeners for interactions with the list item.
//////////////////////////////////////////////////////////////////////////////
function addStockistToList(stockist, marker) {
  // Create the list item element
  const listItem = document.createElement('a');
  listItem.href = '#'; // Set default href
  listItem.className = 'list-group-item list-group-item-action responsive-rounded mb-4'; // Set class for styling
  listItem.dataset.stockistId = stockist.id; // Store the stockist ID in a data attribute

  // Set the inner HTML of the list item with stockist details and action buttons
  /*
  listItem.innerHTML = `
    <div class="row g-3">
      <div class="col-lg-7">
        <h5>${stockist.title}</h5>
        <p class="mb-0">${stockist.address}</p>
        <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(stockist.address)}" target="_blank" class="text-body js-directions-link">Directions</a>
        <p class="mb-0">Phone: ${stockist.phone}</p>
      </div>
      <div class="col-lg-5">
        <div class="d-grid gap-3">
          <button class="btn btn-primary js-view-stockist" data-href="${stockist.link}">View Stockist</button>
          <button class="btn btn-primary-outline js-book-tour" data-href="${stockist.link}#mywaitlist-form">Book a Tour</button>
        </div>
      </div>
    </div>
  `;
  */

  listItem.innerHTML = `
    <div class="row g-3">
      <div class="col-lg-10">
        <a href="${stockist.link}" class="list-group-item-link js-list-group-item-redirect d-block _h5" target="_blank">${stockist.title}</a>
        <p class="mb-0">${stockist.name}</p>
        <p class="mb-0">${stockist.city}${stockist.state}${stockist.zip}</p>
        <p class="mb-0">${stockist.business_hours}</p>
        <a href="tel:${stockist.phone}" class="text-body stockist-phone-link js-stockist-phone-link">${stockist.phone}</a><br>
        <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(stockist.address)}" target="_blank" class="text-body js-directions-link">Directions</a>
        <a href="${stockist.link}" class="list-group-item-icon js-list-group-item-redirect d-block" target="_blank">
          <i href="${stockist.link}" class="icon icon-forward js-list-group-item-redirect"></i>
        </a>
      </div>
    </div>
  `;

  // Add click event listener to the list itemmywaitlist-form
  listItem.addEventListener('click', (event) => {
    const target = event.target;
    if ( target.classList.contains('js-list-group-item-redirect') ) {
      const href = target.getAttribute('href');
      //window.location.href = href;
      window.open(href, '_blank', 'noopener');
    }
    // Handle directions link
    if (target.classList.contains('js-directions-link')) {
      return; // Allow default action for directions link
    }
    // Handle phone link
    if (target.classList.contains('js-stockist-phone-link')) {
      return; // Allow default action for phone link
    }
    // Handle view stockist button
    if (target.classList.contains('js-view-stockist')) {
      event.preventDefault();
      window.location.href = target.getAttribute('data-href');
      return;
    }

    // Handle book tour button
    if (target.classList.contains('js-book-tour')) {
      event.preventDefault();
      window.location.href = target.getAttribute('data-href');
      return;
    }

    // Handle clicking on the list item itself
    event.preventDefault();
    setActiveMarker(marker,true); // Highlight the marker and list item when clicked
  });

  // Append the list item to the stockists list
  document.querySelector('.js-stockists-list').appendChild(listItem);
}

//////////////////////////////////////////////////////////////////////////////
// Scroll to the list item corresponding to the stockist ID
// This function scrolls the stockists list to bring the specified stockist's list
// item into view and highlights it by adding an active class.
//////////////////////////////////////////////////////////////////////////////
function scrollToListItem(stockistId) {
  // Select the list item corresponding to the stockist ID
  const listItem = document.querySelector(`.js-stockists-list a[data-stockist-id="${stockistId}"]`);
  if (listItem) {
    // Add active class to the clicked list item
    listItem.classList.add('active');

    // Select the stockists list container
    const stockistsList = document.querySelector('.js-stockists-list');

    // Scroll the list container so that the list item is at the top
    stockistsList.scrollTop = listItem.offsetTop - stockistsList.offsetTop;

    //jQuery('.js-stockists-list').scrollTop(jQuery('.list-group-item.active').position().top)

    //stockistsList.scrollTop(
    //  listItem.position().top + stockistsList.scrollTop() - stockistsList.offset().top
    //);
    
  }
}

//////////////////////////////////////////////////////////////////////////////
// Update the stockists list in the DOM
// This function updates the list of stockists displayed on the page by clearing
// the existing list and then adding the provided stockists to the list.
//////////////////////////////////////////////////////////////////////////////
function updateStockistList(stockists) {
  // Get the reference to the stockists list element
  const stockistsList = document.querySelector('.js-stockists-list');

  // Clear existing list of stockists
  stockistsList.innerHTML = '';


  if (stockists.length > 0){
    // Iterate through each stockist and add it to the list
    jQuery('.js-stockists-not-found').addClass('d-none');
    jQuery('.js-stockists-list-container').removeClass('d-none');
    stockists.forEach(stockist => {
      addStockistToList(stockist, stockist.marker);
    });
  }else{
    jQuery('.js-stockists-not-found').removeClass('d-none');
    jQuery('.js-stockists-list-container').addClass('d-none');
  }
}

//////////////////////////////////////////////////////////////////////////////
// Scroll to the map section
//////////////////////////////////////////////////////////////////////////////
function scrollToMapSection() {
  // Select the map section and sticky element
  const mapSection = document.querySelector('.js-section-stockists-map');
  const stickyElement = document.querySelector('.js-sticky-top');

  // Proceed if the map section exists
  if (mapSection) {
    // Calculate the height of the sticky element, if it exists
    const stickyHeight = stickyElement ? stickyElement.offsetHeight : 0;
    // Additional offset to account for extra spacing
    const additionalOffset = 60;
    // Calculate the top position of the map section, accounting for sticky height and additional offset
    // const mapSectionTop = mapSection.getBoundingClientRect().top + window.scrollY - stickyHeight - additionalOffset;
    const mapSectionTop = mapSection.getBoundingClientRect().top + window.scrollY - additionalOffset;

    // Smoothly scroll to the calculated top position
    window.scrollTo({
      top: mapSectionTop,
      behavior: 'smooth'
    });
  }
}

//////////////////////////////////////////////////////////////////////////////
// Adjust the map center to fit the specified half of the map based on breakpoints
//////////////////////////////////////////////////////////////////////////////
function adjustMapCenter() {
  const bounds = map.getBounds();
  if (bounds) {
    const center = bounds.getCenter();
    const span = bounds.toSpan();
    const shouldOffset = mapConfig.enableOffset && shouldEnableOffset();
    const offsetDirection = mapConfig.offsetDirection === 'left' ? 1 : -1;

    // Calculate the new center point to shift the map center by 1/4 of the map width if offsetting is enabled
    const newCenter = {
      lat: center.lat(),
      lng: shouldOffset ? center.lng() + offsetDirection * (span.lng() / 2) : center.lng() // Apply offset if enabled
    };

    // Set the new center of the map
    map.setCenter(newCenter);
  } else {
    // If bounds are not yet defined, retry after a short delay
    setTimeout(adjustMapCenter, 100);
  }
}

//////////////////////////////////////////////////////////////////////////////
// Determine if offset should be enabled based on screen width and breakpoints
// This function checks the current screen width against the defined breakpoints
// in the mapConfig to decide if the map offset should be enabled.
//////////////////////////////////////////////////////////////////////////////
function shouldEnableOffset() {
  const screenWidth = window.innerWidth;

  // Check breakpoints in descending order to apply the correct rule
  const breakpoints = Object.keys(mapConfig.mediaQueryBreakpoints).sort((a, b) => b - a);

  for (const breakpoint of breakpoints) {
    if (screenWidth >= breakpoint) {
      return mapConfig.mediaQueryBreakpoints[breakpoint];
    }
  }

  // If screen width is less than the smallest breakpoint, return false
  return false;
}

//////////////////////////////////////////////////////////////////////////////
// Create a debug pin for visualisation
// This function creates a debug pin at a given position on the map using the
// specified icon URL. It adds the debug pin to the map and stores a reference
// to the debug pin in the debugPins array for future manipulation.
//////////////////////////////////////////////////////////////////////////////
function createDebugPin(position, iconUrl) {
  // Create a new marker for the debug pin
  const debugPin = new google.maps.Marker({
    position: position, // Set the position of the debug pin
    map: map, // Associate the debug pin with the map
    icon: {
      url: iconUrl, // URL for the debug pin icon
      scaledSize: new google.maps.Size(30, 30) // Adjust size of the debug pin icon
    }
  });
  // Store reference to the debug pin in the debugPins array
  debugPins.push(debugPin);
}

//////////////////////////////////////////////////////////////////////////////
// Clear debug pins
// This function iterates over all debug pins stored in the debugPins array
// and removes them from the map. It then clears the debugPins array to
// reset the stored references.
//////////////////////////////////////////////////////////////////////////////
function clearDebugPins() {
  // Iterate over all debug pins and remove them from the map
  debugPins.forEach(pin => pin.setMap(null));
  // Reset the debugPins array after clearing the pins
  debugPins = [];
}


//////////////////////////////////////////////////////////////////////////////
// refresh clustering
//////////////////////////////////////////////////////////////////////////////
function refreshMarkerClustering(){
  const zoom = map.getZoom();
  if(zoom <= mapConfig.clustering.maxZoom){
    markerClusterer.clearMarkers();
    markerClusterer.addMarkers(markersObject);
  }
}
//////////////////////////////////////////////////////////////////////////////
// update marker clustering
//////////////////////////////////////////////////////////////////////////////
function createMarkerClustering(){
  if(mapConfig.clustering.enabled){
    markerClusterer = new MarkerClusterer( null, [], {
      styles: [{
        anchorIcon: [mapConfig.icons.height,mapConfig.icons.width / 2],
        textColor: mapConfig.clustering.textColor,
        height: mapConfig.icons.height,
        width: mapConfig.icons.width,
        textSize: mapConfig.clustering.textSize,
        url: mapConfig.icons.inactive,
        anchorText: [-7, 0],      
      }],
      gridSize: mapConfig.clustering.gridSize,
      //minimumClusterSize: 2,
      maxZoom: mapConfig.clustering.maxZoom
    });

    // make sure all markers are created before displaying
    setTimeout(() => {
      markerClusterer.addMarkers(markersObject);
      markerClusterer.setMap(map);
    }, 200);


  }
}